import { toQueryString } from "./urlHelpers";

export const communitiesPaths = {
  onboarding: () => "/getting-started",
  templates: (communityId: string) => `/communities/${communityId}/templates`,
  questions: (communityId: string) => `/communities/${communityId}/questions`,
  questionsWithVariant: (communityId: string, variant: string) =>
    `${communitiesPaths.questions(communityId)}?variant=${variant}`,
  feed: () => "/feed",
  recap2025: () => "/settings/recap-2025",
  recap2025ForMembersAndNonMembers: () => "/2025",
};

export const memberDirectoryPath = () => "/members";
export const coursesDirectoryPath = () => "/courses";
export const spacesDirectoryPath = () => "/spaces";
export const eventsDirectoryPath = () => "/events";

export type Params = Record<string, any>;

export const onboardingItemPathQueryParam = (param: Params) =>
  `${communitiesPaths.onboarding()}?${toQueryString(param)}`;

export const featureSelectionPagePath = (communityId: string) =>
  communitiesPaths.templates(communityId);
export const goalQuestionPagePath = (communityId: string) =>
  communitiesPaths.questionsWithVariant(communityId, "goals");

export const isFeatureSelectionPage = (pathname: string) =>
  pathname.endsWith("/templates");
export const isGoalQuestionPage = (pathname: string, search: string) =>
  pathname.endsWith("/questions") && search.includes("variant=goals");

export const revenueQuestionsPagePath = (communityId: string) =>
  communitiesPaths.questions(communityId);
export const isRevenueQuestionsPage = (pathname: string, search: string) =>
  pathname.endsWith("/questions") && !search.includes("variant=");
